<template>
    <div style="background-color: #fff;">
        <div v-if="alarmList && alarmList.length > 0">

            <single_fault_info v-for="(item, index) in alarmList" :key="index" :info="item" :index="index"
                style="margin-bottom: 16px;" />
        </div>
        <div v-else>
          <kl-empty />  
        </div>

    </div>
</template>
<script>
import single_fault_info from "./single_fault_info"
export default {
    props: {
        info: {
            type: String,
            default: ""
        }

    },
    watch: {
        info: {
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.queryFaultData();
                }
            },
            immediate: true
        }
    },

    components: {
        single_fault_info
    },
    data() {
        return {
            alarmList: []
        }
    },
    mounted() {
        this.queryFaultData();
    },

    methods: {
        queryFaultData() {
            //故障数据查询，最近一个小时
            var startDate = this.moment().subtract(1, 'hours').format('YYYY-MM-DD HH:mm:ss');
            var endDate = this.moment().format('YYYY-MM-DD HH:mm:ss');

            this.$api.FailureInfo({
                StartDate: startDate,//startTime,//"2023-09-17",//startTime,
                EndDate: endDate,//endTime,//"2023-09-17",//endTime,
                // vehicles:this.vehicles,
                vehicles: "",//暂定只差全部车辆，后续确认
                OperatorID: this.$store.getters.operator.OperatorId,
                SubjectCorpID: this.$store.getters.operator.CompanyId,
                info: this.info,//"LDU00014",//这个是车号
                pageNo: 1,
                pageSize: 5,
                Language: this.LanguageId,
                IsExport: 0, // 0是查询 1是下载
            })
                .then((res) => {
                    console.log(res);
                    if (res && res.code == 200) {
                        this.alarmList = res.data;

                    }
                });
        },
    }
}
</script>